/* eslint-disable */
import React, { useEffect, useState, useContext } from 'react';
import {
  Row,
  Col
} from 'react-bootstrap';
import { useForm } from "react-hook-form";
import EstadosLista from '../slEstados.component';
import detalleFunction from '../../views/detalle/detalle.function';
import notification from '../notification.component';
import general from '../../general/general.functions';
import { ConfigContextUtils } from '../../context/contextUtils.context';

const Destinatario = ({ onClose, data, show, onUpdate }) => {

  const { setPreloader } = useContext(ConfigContextUtils);
  const [paisesp, setPaisesp] = useState([]);
  const [multiselect, setMultiSelect] = useState(false);
  const { register, handleSubmit, errors, reset, setValue } = useForm();

  const onSubmit = (data) => {
    setPreloader(true);
    detalleFunction.destinatario(data).then((respuesta) => {
       if (respuesta.destinatario_actualizado) {
        notification.success();
        onUpdate();
        onClose();
       } else {
        notification.waring('El destinatario no puede ser editado.');
       }
       setPreloader(false);
    })
  }

  useEffect(() => {
    reset({
      identificacion: data.cliente_receptor_identificacion,
      nombre: data.cliente_receptor_nombre,
      telefono: data.cliente_receptor_telefono,
      direccion: data.cliente_receptor_direccion_entrega,
      id: data.id,
    });
    
    general.paises().then((respuesta) => {
      setPaisesp(respuesta.response);
    }); 
  },[]);

  useEffect(() => {
    if (paisesp.length) {
      setValue('pais', data.pais_guia.id);
      setMultiSelect(data.pais_guia.multiselect);
      if (data.pais_guia.multiselect) {
        setValue('estado', 'null');
        setValue('ciudad', 'null');
      }
    }
  },[paisesp])

  const selectPais = (event) => {
    const id = event.target.value;
    if (id !== 'null') {
      const index = paisesp.findIndex(val => val.id === parseInt(id)); 
      const values = paisesp[index];
      setMultiSelect(values.multiselect);
      if (!values.multiselect) {
        setValue('estado', 26);
        setValue('ciudad', 523);
      } else {
        setValue('estado', 'null');
        setValue('ciudad', 'null');
      }
    } else {
      setMultiSelect(false);
    }
  }

  return (
    <>
     <form onSubmit={handleSubmit(onSubmit)}>
      <Row>
        <Col>
              <div className="grupo-input">
                <small>Identificación</small>
                <input type="text" className={`form-control input-border ${errors.identificacion && "is-invalid"}`} name="identificacion" ref={register({ required: true })} />
              </div>
              <div className="grupo-input">
                <small>Nombre</small>
                <input type="text" className={`form-control input-border ${errors.nombre && "is-invalid"}`} name="nombre" ref={register({ required: true })} />
              </div>
              <div className="grupo-input">
                <small>Telefono</small>
                <input type="text" className={`form-control input-border ${errors.telefono && "is-invalid"}`} name="telefono" ref={register({ required: true })} />
              </div>
              <div className="grupo-input">
                <small>Dirección de entrega</small>
                <input type="text" className={`form-control input-border ${errors.direccion && "is-invalid"}`} name="direccion" ref={register({ required: true })} />
              </div>

              <div className="grupo-input">
                <small>País</small>
                <select onChange={selectPais} className={`form-control input-border ${errors.pais && "is-invalid"}`} name="pais" ref={register({ required: true, validate: value => value !== 'null' })}>
                  <option value="null">Seleccione...</option>
                  {paisesp.map((item, index) => {
                    return <option key={item.id} value={item.id}>{item.country}</option>
                  })}
                </select>
              </div>
              {multiselect ?
              <EstadosLista 
                onValue={(value) => console.log('-')}
                register={register}
                errors={errors}
                valueEstado={data.estado_guia.id}
                valueCiudad={data.ciudad_guia.id_ciudad}
                show={show}
                multiselect={multiselect}
              /> : null }
        </Col>
      </Row>
      <Row>
        <Col className="d-flex justify-content-end mt-3">
          <input type="hidden" name="id" ref={register({ required: true })} />
          <button type="submit" className="btnx btnx-warn mr-2">Guardar</button>
          <button onClick={() => onClose()}  type="button" className="btnx btnx-warn">Cancelar</button>
        </Col>
      </Row>
      </form>
    </>
  )
}

export default Destinatario;